/*
  Pointhome – Montageservice im Warenkorb (Theme: Hyper)
  Datei: assets/montage-option.js
  Einbinden in layout/theme.liquid vor </body>:
      <script src="{{ 'montage-option.js' | asset_url }}" defer></script>

  Was das Script macht:
    - Checkbox an  -> fügt das Produkt "montageservice" (199 €) zum Warenkorb hinzu,
                      verknüpft mit dem Bett über die Zeilen-Eigenschaften
                      "Für" (sichtbar im Checkout) und "_bed_key" (unsichtbar)
    - Checkbox aus -> entfernt genau diese Service-Zeile
    - Abgleich     -> Bett entfernt => Service entfernt; Bett-Menge = Service-Menge
                      (läuft auch, wenn das Theme den Warenkorb selbst neu rendert)
    - Anzeige      -> rendert die betroffene Section per Section Rendering API neu;
                      falls das fehlschlägt, wird die Seite neu geladen
    - Styles werden einmalig eingefügt (keine extra CSS-Datei nötig)
*/
(function () {
  if (window.__pointhomeMontage) return;
  window.__pointhomeMontage = true;

  var SERVICE_HANDLE = 'montageservice';
  var FORCE_RELOAD = false; // auf true setzen, falls die Section-Aktualisierung im Theme Probleme macht
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  /* ---------- Styles ---------- */
  var style = document.createElement('style');
  style.textContent = [
    '.montage-option{width:100%;box-sizing:border-box;margin-top:12px;background:#f4f4f4;border-radius:8px;padding:12px 14px;color:#14323C;font-size:14px;line-height:1.35}',
    '.montage-option__label{display:flex;align-items:center;gap:12px;cursor:pointer;margin:0}',
    '.montage-option__icon{flex:none;display:flex;width:22px;height:22px}',
    '.montage-option__text{flex:1;min-width:0}',
    '.montage-option__link{color:inherit;text-decoration:underline;text-underline-offset:2px;font-weight:600}',
    '.montage-option__link--plain{text-decoration:none}',
    '.montage-option__hint{display:block;margin-top:3px;font-size:12px;color:#5f6f74}',
    '.montage-option__price{font-weight:700;white-space:nowrap}',
    '.montage-option__checkbox{flex:none;width:22px;height:22px;margin:0;cursor:pointer;accent-color:#14323C}',
    '[data-montage-option].is-loading{opacity:.5;pointer-events:none}',
    /* ---- Warenkorbseite: eigene Tabellenzeile mit 3 Zellen (Produkt / Menge / Gesamt) ---- */
    /* Der graue Kasten liegt als ::before hinter jeder Zelle; unten bleiben 16px frei als Abstand zur Trennlinie */
    'tr.montage-row>td{position:relative;isolation:isolate;vertical-align:middle;padding-top:0!important;padding-bottom:16px!important;border-top:0!important;color:#14323C;font-size:14px;line-height:1.35}',
    'tr.montage-row>td::before{content:"";position:absolute;left:0;right:0;top:0;bottom:16px;background:#f4f4f4;z-index:-1}',
    'tr.montage-row>td.montage-row__cell--first::before{border-radius:8px 0 0 8px}',
    'tr.montage-row>td.montage-row__cell--last::before{border-radius:0 8px 8px 0}',
    'tr.cart-item:has(+tr.montage-row)>td{border-bottom:0!important}',
    'tr.montage-row .montage-row__label{padding:12px 0 12px 14px}',
    'tr.montage-row .montage-row__right{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 14px 12px 0}',
    /* Unter 1024px (Theme blendet die Spalten Menge/Gesamt aus): Zellen untereinander stapeln */
    '@media (max-width:1023px){',
    '  tr.montage-row>td.montage-row__cell--first{display:block!important;padding-bottom:0!important;border-bottom:0!important}',
    '  tr.montage-row>td.montage-row__cell--first::before{bottom:0;border-radius:8px 8px 0 0}',
    '  tr.montage-row>td.montage-row__cell--last{display:block!important}',
    '  tr.montage-row>td.montage-row__cell--last::before{border-radius:0 0 8px 8px}',
    '  tr.montage-row .montage-row__label{padding-bottom:4px}',
    '  tr.montage-row .montage-row__right{padding-left:48px;padding-top:4px}',
    '}',
    /* Mengenauswahl in der Service-Zeile ausblenden – die Menge folgt automatisch dem Bett */
    '.montage-service-row quantity-input,.montage-service-row .quantity,.montage-service-row .cart-quantity{display:none!important}'
  ].join('\n');
  document.head.appendChild(style);

  /* ---------- Hilfsfunktionen ---------- */
  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' -> HTTP ' + r.status);
      return r.json();
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* Service-Zeilen mit den Betten abgleichen.
     Rückgabe: true, wenn etwas geändert wurde. */
  function reconcile() {
    return getCart().then(function (cart) {
      var updates = {};
      var changed = false;
      cart.items.forEach(function (line) {
        if (line.handle !== SERVICE_HANDLE) return;
        var bedKey = line.properties && line.properties._bed_key;
        var bed = null;
        if (bedKey) {
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === bedKey) { bed = cart.items[i]; break; }
          }
        }
        var want = bed ? bed.quantity : 0; // ohne Bett (oder direkt über die Produktseite gelandet) -> raus
        if (want !== line.quantity) { updates[line.key] = want; changed = true; }
      });
      if (!changed) return false;
      return post('cart/update.js', { updates: updates }).then(function () { return true; });
    });
  }

  /* ---------- Anzeige aktualisieren ---------- */
  /* Sections, in denen Montage-Elemente liegen: je Section das Wurzelelement (z. B. <cart-drawer>),
     das direkt unter dem Section-Wrapper sitzt. */
  function sectionRoots() {
    var roots = [];
    document.querySelectorAll('[data-montage-option], [data-montage-service-line]').forEach(function (el) {
      var wrap = el.closest('[id^="shopify-section-"]');
      if (!wrap) return;
      var root = el;
      while (root.parentElement && root.parentElement !== wrap) root = root.parentElement;
      if (root.parentElement !== wrap) return;
      var known = roots.some(function (r) { return r.root === root; });
      if (!known) roots.push({ wrap: wrap, root: root });
    });
    return roots;
  }

  /* Eine Theme-Section per Section Rendering API neu laden.
     Das Wurzelelement bleibt erhalten (ein offener Drawer bleibt offen), nur sein Inhalt wird ersetzt. */
  function rerenderSection(entry) {
    var id = entry.wrap.id.replace('shopify-section-', '');
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(id);
    return fetch(url, { headers: { Accept: 'text/html' } }).then(function (r) {
      if (!r.ok) throw new Error('section ' + id + ' -> HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById(entry.wrap.id) || doc.body;
      var oldRoot = entry.root;
      var newRoot = null;
      if (oldRoot.id) newRoot = doc.getElementById(oldRoot.id);
      if (!newRoot) {
        for (var i = 0; i < fresh.children.length; i++) {
          if (fresh.children[i].tagName === oldRoot.tagName) { newRoot = fresh.children[i]; break; }
        }
      }
      if (!newRoot) throw new Error('section root not found: ' + id);
      while (oldRoot.firstChild) oldRoot.removeChild(oldRoot.firstChild);
      while (newRoot.firstChild) oldRoot.appendChild(newRoot.firstChild);
    });
  }

  function refresh() {
    // Warenkorbseite: komplett neu laden (Summen, Kopfzeile, alles sicher aktuell)
    if (FORCE_RELOAD || window.location.pathname.indexOf('/cart') !== -1) { window.location.reload(); return; }
    // Andere Seiten (Drawer): nur die Drawer-Section neu rendern
    var roots = sectionRoots();
    if (!roots.length) return;
    Promise.all(roots.map(rerenderSection)).catch(function (err) {
      console.warn('[Montageservice] Section-Update fehlgeschlagen, lade Seite neu', err);
      window.location.reload();
    });
  }

  /* ---------- Service-Zeilen markieren ---------- */
  var markQueued = false;
  function markServiceRows() {
    if (markQueued) return;
    markQueued = true;
    requestAnimationFrame(function () {
      markQueued = false;
      document.querySelectorAll('[data-montage-service-line]').forEach(function (m) {
        var row = m.closest('.cart-item, tr, li');
        if (row) row.classList.add('montage-service-row');
      });
    });
  }

  /* ---------- Checkbox ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!(input instanceof HTMLInputElement) || !input.classList.contains('montage-option__checkbox')) return;
    var opt = input.closest('[data-montage-option]');
    if (!opt) return;
    if (busy) { input.checked = !input.checked; return; }

    busy = true;
    opt.classList.add('is-loading');
    var d = opt.dataset;
    var request;

    if (input.checked) {
      request = post('cart/add.js', {
        items: [{
          id: Number(d.serviceVariant),
          quantity: Number(d.bedQty) || 1,
          properties: { 'Für': d.bedTitle, '_bed_key': d.bedKey }
        }]
      });
    } else if (d.serviceKey) {
      request = post('cart/change.js', { id: d.serviceKey, quantity: 0 });
    } else {
      request = Promise.resolve();
    }

    request
      .then(reconcile)
      .then(function () { busy = false; refresh(); })
      .catch(function (err) {
        console.error('[Montageservice]', err);
        input.checked = !input.checked;
        busy = false;
        opt.classList.remove('is-loading');
      });
  });

  /* ---------- Abgleich bei Start und nach Theme-Rendern ---------- */
  function signature() {
    var parts = [];
    document.querySelectorAll('[data-montage-option]').forEach(function (o) {
      parts.push(o.dataset.bedKey + ':' + o.dataset.bedQty + ':' + o.dataset.serviceQty);
    });
    parts.push('svc' + document.querySelectorAll('[data-montage-service-line]').length);
    return parts.join('|');
  }

  var lastSig = null;
  function runReconcile() {
    if (busy) return;
    markServiceRows();
    reconcile().then(function (changed) { if (changed) refresh(); }).catch(function () {});
  }

  function init() {
    markServiceRows();
    lastSig = signature();
    if (document.querySelector('[data-montage-option], [data-montage-service-line]')) runReconcile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Rendert das Theme den Warenkorb neu (Menge geändert, Produkt entfernt), ändert sich die Signatur -> Abgleich
  var sigTimer = null;
  new MutationObserver(function () {
    markServiceRows();
    clearTimeout(sigTimer);
    sigTimer = setTimeout(function () {
      var s = signature();
      if (s !== lastSig) { lastSig = s; runReconcile(); }
    }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Dawn-basierte Themes melden Änderungen zusätzlich über "cart-update"
  if (typeof window.subscribe === 'function') {
    window.subscribe('cart-update', function () { setTimeout(runReconcile, 50); });
  }
})();
